import { render, staticRenderFns } from "./FlagGermany.vue?vue&type=template&id=0256c4af&"
import script from "./FlagGermany.vue?vue&type=script&lang=js&"
export * from "./FlagGermany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports